<template>
    <div id="Structure">

        <Head />
        <div class="hotspot clear">
            <Nav ms="/Structure" />
            <div class="H-right">
                <div class="title">组织架构管理</div>
                <div class="btn1" @click="excel()">
                    <i></i>
                    导出数据
                </div>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="组织架构" name="first">

                        <div class="block">
                            <Mytree :list="tableData"></Mytree>
                            <div class="getcompany" style="display: none" @click="Popups"></div>

                        </div>
                        <div style="width: 100%; height: 300px">
                            <el-backtop :bottom="100" style="width: 50px; height: 50px">
                                <!-- <div> -->
                                <img src="../../assets/back/up.png" alt style="width: 50px; height: 50px" />
                                <!-- </div> -->
                            </el-backtop>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="组织列表" name="second">
                        <span>企业名称 </span>
                        <input type="text" placeholder="请输入要查询企业名称" v-model="name" />
                        <span>手机号 </span>
                        <input type="text" placeholder="请输入要查询的手机号" v-model="phone" />
                        <el-table border :header-cell-style="{
                            'background-color': '#001743',
                            color: '#fff',
                            height: '0.5rem',
                        }" :data="tableDatas" :row-style="{ height: '0.4rem' }">
                            <el-table-column type="index" label="序号" width="60" header-align="center"
                                align="center"></el-table-column>
                            <el-table-column prop="Name" label="企业名称" header-align="center" width="150"
                                align="center"></el-table-column>
                            <el-table-column prop="Manager" width="100" label="联系人" header-align="center"
                                align="center"></el-table-column>
                            <el-table-column prop="Phone" width="130" label="手机号" header-align="center"
                                align="center"></el-table-column>
                            <el-table-column prop="RankName" width="120" label="公司等级" header-align="center"
                                align="center"></el-table-column>
                            <el-table-column prop="Status" width="120" label="状态" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-tag
                                        :type="scope.row.Status == '1' ? 'primary' : scope.row.Status == '2' ? 'danger' : 'warning'">{{ scope.row.Status == '1' ? '正常' : scope.row.Status == '2' ? '已禁用' : '待审核' }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="SuperiorDName" width="150" label="上级名称" header-align="center"
                                align="center"></el-table-column>
                            <el-table-column prop="ProvinceName" width="150" label="所属省份" header-align="center"
                                align="center"></el-table-column>
                            <el-table-column label="操作" width="120" fixed="right" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="medium"
                                        @click="getdata((companyvalue = scope.row.ID))">查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination style="text-align: right; height: 0.45rem" @current-change="CurrentChange1"
                            @size-change="handleSizeChange1" :current-page="Page1" :page-size="PageSize1"
                            :page-sizes="[10, 20, 30]" layout="total,sizes, prev, pager, next, jumper"
                            :total="total"></el-pagination>
                        <div style="width: 100%; height:100px">
                            <el-backtop :bottom="100" style="width: 50px; height: 50px">
                                <!-- <div> -->
                                <img src="../../assets/back/up.png" alt style="width: 50px; height: 50px" />
                                <!-- </div> -->
                            </el-backtop>
                        </div>
                    </el-tab-pane>
                </el-tabs>

                <!-- <div class="Popup" v-show="isPopup"> -->
                <el-dialog width="60%" title="公司详情" :visible.sync="detailVisible">
                    <!-- <div class="none" @click="Popups(0)"></div> -->
                    <div class="a_forms">
                        <div class="f-top">
                            <!-- <div @click="Popups(0)"></div>
                            公司详情 -->
                        </div>
                        <div class="f-info">
                            <div class="f-title">
                                <div class="f-left">
                                    <div>
                                        <span>名称</span>
                                        <a>:</a>
                                        <span @click="show('名称')" v-if="!user.Name && table.Name" class="toInput"></span>
                                        <em @click="show('名称')" v-if="table.Name">{{ user.Name }}</em>
                                        <input v-else @blur="yincang('名称')" type="text" v-model="user.Name" />
                                    </div>
                                    <div>
                                        <span>隶属关系</span>
                                        <a>:</a>
                                        <span @click="show('隶属关系')" v-if="!user.SuperiorDName && table.SuperiorDName"
                                            class="toInput"></span>
                                        <em @click="show('隶属关系')" v-if="table.SuperiorDName">{{
                                            user.SuperiorDName
                                        }}</em>
                                        <el-button type="text" @click="changeSuperiorDName">更改所属</el-button>
                                        <!-- <input v-else @blur="yincang('隶属关系')" type="text" v-model="user.SuperiorDName" /> -->
                                        <!-- <em>{{user.SuperiorDName}}</em>  -->
                                    </div>
                                    <div>
                                        <span>地址</span>
                                        <a>:</a>
                                        <span @click="show('地址')" v-if="!user.City && table.City" class="toInput"></span>
                                        <em @click="show('地址')" v-if="table.City">{{ user.City }}</em>
                                        <input v-else @blur="yincang('地址')" type="text" v-model="user.City" />
                                        <!-- <em>{{user.City}}</em>-->
                                    </div>
                                    <div>
                                        <span>企业性质</span>
                                        <a>:</a>
                                        <span @click="show('企业性质')" v-if="!user.PropertyName && table.PropertyName"
                                            class="toInput"></span>
                                        <em @click="show('企业性质')" v-if="table.PropertyName">{{
                                            user.PropertyName
                                        }}</em>
                                        <!-- <input v-else @blur="yincang('企业性质')"  type="text" v-model="user.PropertyName"> -->
                                        <select style="margin-left: 0.3rem" @change="getqiye" v-else
                                            v-model="user.Property">
                                            <option value>请选择企业性质</option>
                                            <option v-for="(item, i) in propertyList" :key="i" :value="item.code">
                                                {{ item.codename }}
                                            </option>
                                        </select>
                                        <!-- <em>{{user.PropertyName}}</em> -->
                                    </div>
                                    <div>
                                        <span>邮箱</span>
                                        <a>:</a>
                                        <span @click="show('邮箱')" v-if="!user.Email && table.Email" class="toInput"></span>
                                        <em @click="show('邮箱')" v-if="table.Email">{{ user.Email }}</em>
                                        <input v-else @blur="yincang('邮箱')" type="text" v-model="user.Email" />
                                        <!-- <em>{{user.Email}}</em> -->
                                    </div>
                                    <div>
                                        <span>联系人员</span>
                                        <a>:</a>
                                        <span @click="show('联系人员')" v-if="!user.Manager && table.Manager"
                                            class="toInput"></span>
                                        <em @click="show('联系人员')" v-if="table.Manager">{{ user.Manager }}</em>
                                        <input v-else @blur="yincang('联系人员')" type="text" v-model="user.Manager" />
                                        <!-- <em>{{user.Manager}}</em> -->
                                    </div>
                                    <div>
                                        <span>所在部门</span>
                                        <a>:</a>
                                        <span @click="show('所在部门')" v-if="!user.Department && table.Department"
                                            class="toInput"></span>
                                        <em @click="show('所在部门')" v-if="table.Department">{{
                                            user.Department
                                        }}</em>
                                        <input v-else @blur="yincang('所在部门')" type="text" v-model="user.Department" />
                                        <!-- <em>{{user.Department}}</em> -->
                                    </div>
                                    <div class="qyjj">
                                        <span>企业简介</span>
                                        <a>:</a>
                                        <span @click="show('企业简介')" v-if="!user.introduction && table.introduction"
                                            class="toInput"></span>
                                        <div class="txt" @click="show('企业简介')" v-if="table.introduction"
                                            v-html="user.introduction ? user.introduction : '暂无企业简介'"></div>
                                        <wangEditor v-else @blur="yincang('企业简介')" v-model="user.introduction" />
                                        <!-- <div @click="show('企业简介')" v-if="table.introduction">{{
                        user.introduction
                      }}</div>
                      <textarea
                        v-else
                        @blur="yincang('企业简介')"
                        rows="5"
                        v-model="user.introduction"
                      ></textarea> -->
                                    </div>
                                    <div>
                                        <el-button type="primary" size="small"
                                            @click="dialogFormVisible = true">重置密码</el-button>
                                        <el-button type="primary" size="small" v-if="useRtype"
                                            @click="dialogFormVisible1 = true">查看员工</el-button>
                                    </div>
                                </div>
                                <div class="f-left f-right">
                                    <div>
                                        <span>职务</span>
                                        <a>:</a>
                                        <span @click="show('职务')" v-if="!user.Position && table.Position"
                                            class="toInput"></span>
                                        <em @click="show('职务')" v-if="table.Position">{{ user.Position }}</em>
                                        <input v-else @blur="yincang('职务')" type="text" v-model="user.Position" />
                                        <!-- <em>{{user.Position}}</em> -->
                                    </div>
                                    <div>
                                        <span>联系电话</span>
                                        <a>:</a>
                                        <span @click="show('联系电话')" v-if="!user.Phone && table.Phone"
                                            class="toInput"></span>
                                        <em @click="show('联系电话')" v-if="table.Phone">{{ user.Phone }}</em>
                                        <input v-else @blur="yincang('联系电话')" type="text" v-model="user.Phone" />
                                        <!-- <em>{{user.Phone}}</em> -->
                                    </div>
                                    <div>
                                        <span>统一代码</span>
                                        <a>:</a>
                                        <span @click="show('统一代码')" v-if="!user.Code && table.Code" class="toInput"></span>
                                        <em @click="show('统一代码')" v-if="table.Code">{{ user.Code }}</em>
                                        <input v-else @blur="yincang('统一代码')" type="text" v-model="user.Code" />
                                        <!-- <em>{{user.Code}}</em> -->
                                    </div>
                                    <div>
                                        <span>营业执照</span>
                                        <a>:</a>
                                    </div>
                                    <div>
                                        <el-button type="primary" style="margin-top: -0.2rem" @click="uploadImg"
                                            size="small">
                                            上传
                                            <i class="el-icon-upload el-icon--right"></i>
                                        </el-button>
                                        <!-- <img
                        v-if="!user.Image"
                        :src="require('../../assets/back/110.png')"
                        alt="营业执照"
                      />-->
                                        <el-image style="
                          max-width: 3rem;
                          max-height: 2rem;
                          margin-left: 1.2rem;
                          margin-top: -0.32rem;
                        " :preview-src-list="[user.Image || require('../../assets/back/110.png')]"
                                            :src="user.Image || require('../../assets/back/110.png')" alt="营业执照"></el-image>
                                    </div>
                                </div>
                            </div>
                            <div class="f-bottom">
                                <span style="margin-right: 0.2rem">一键直报</span>
                                <el-radio v-model="user.Specificity" label="1">是</el-radio>
                                <el-radio v-model="user.Specificity" label="0">否</el-radio>
                            </div>
                            <div class="f-bottom">
                                <span style="margin-left: 0.3rem">状态{{ user.Status == 0 ? "(未审核)" : "" }}</span>
                                <select v-model="user.Status" style="width: 2rem; height: 0.4rem; margin-left: 0.2rem">
                                    <option value="1">正常</option>
                                    <option value="2">停用</option>
                                </select>
                            </div>
                            <div class="f-bottom">
                                <div @click="setInfo" class="btn btnmini" style="margin-left: 2.8rem; width: 1.5rem">
                                    确认修改
                                </div>
                                <div @click="del" class="btn btnmini" style="
                      margin-left: 1rem;
                      width: 1.5rem;
                      background: #fb1752;
                    ">
                                    删除用户
                                </div>
                            </div>
                        </div>
                    </div>
                </el-dialog>
                <!-- </div> -->

            </div>
            <el-dialog width="30%" title="修改密码" style="text-align: center" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="新密码:" :label-width="formLabelWidth">
                        <el-input placeholder="请输入新密码密码" type="password" v-model="form.password1"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码:" :label-width="formLabelWidth">
                        <el-input placeholder="请输入新密码密码" type="password" v-model="form.password2"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="changpswd">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog width="40%" :visible.sync="bigImg">
                <img :src="user.Image" style="
            max-width: 100%;
            max-height: 100%;
            display: block;
            margin: 0px auto;
          " alt />
            </el-dialog>
            <el-dialog width="62%" style="text-align: center" :visible.sync="dialogFormVisible1" class="el_bgj">
                <Bgjurisdiction v-if="dialogFormVisible1" :isAdmin="false" class="bgj" :CompanyID="CompanyID">
                </Bgjurisdiction>
                <!-- <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="changpswd">确 定</el-button>
        </div>-->
            </el-dialog>
            <el-dialog width="40%" :visible.sync="bigImg">
                <img :src="user.Image" style="
            max-width: 100%;
            max-height: 100%;
            display: block;
            margin: 0px auto;
          " alt />
            </el-dialog>
            <el-dialog width="35%" title="修改隶属关系" :visible.sync="SuperiorD" :close-on-click-modal="false">
                <el-form :model="form">
                    <el-form-item label="隶属关系：" prop="SuperiorIds">
                        <el-cascader ref="myCascader" v-if="showCascader" v-model="SuperiorIds" :options="tableData"
                            style="width: 350px;" :props="checkboxProps" :show-all-levels="false"></el-cascader>
                    </el-form-item>
                    <span style="color: #fb1752;">*确认修改后将会刷新组织架构</span>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="SuperiorD = false">取 消</el-button>
                    <el-button type="primary" @click="changeSuperior">确 定</el-button>
                </div>
            </el-dialog>
            <!-- <template>
        <el-backtop target=".hotspot clerar" style="right:40px;bottom:40px">
          <i class="el-icon-caret-top"></i>
        </el-backtop>
      </template>-->
        </div>

        <Foot />
        <el-upload ref="uploads" id="upload1" style="opacity: 0; height: 0; overflow: hidden" class="avatar-uploader1"
            :http-request="upload" :auto-upload="false" action="upload1" :on-success="handleSuccess"
            :on-change="submitUpload" :show-file-list="false" :before-upload="beforeAvatarUpload"
            accept=".jpg, .jpeg, .png">
            <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
    </div>
</template>
<script>
import Bgjurisdiction from "./Bgjurisdiction";
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
import Mytree from "../../components/BackmenuList";
import wangEditor from "../../components/wangEnduit/wangEnduitReport";
export default {
    name: "Jurisdiction",
    data() {
        return {
            dialogFormVisible: false,
            dialogFormVisible1: false,
            activeName: 'first',
            companyName: '',
            tableDatas: [],
            Page1: 1,
            PageSize1: 30,
            total: "",
            form: {
                ID: "",
                password1: "",
                password2: "",
            },

            bigImg: false,
            formLabelWidth: "100px",
            isPopup: 0,
            user: {},
            tableData: [],
            table: {
                Name: true,
                SuperiorDName: true,
                City: true,
                PropertyName: true,
                Email: true,
                Manager: true,
                Department: true,
                Position: true,
                Phone: true,
                Code: true,
                introduction: true,
            },
            propertyList: [],
            property: "",
            sum: [],
            useRtype: true,
            CompanyID: "",
            name: "",
            phone: "",
            SuperiorD: false,
            checkboxProps: {
                checkStrictly: true,
                value: 'ID',
                label: 'Name'
            },
            detailVisible: false,
            showCascader: true
        };
    },
    created() {
        this.getInfo();
        this.getcompanyList()
        var that = this;
        that.$axios
            .post(
                "parameter/info",
                that.$qs.stringify({
                    tablename: "company",
                    fieldname: "Property",
                })
            )
            .then((res) => {
                if (res.data.code == 10000) {
                    console.log(res.data, 1);
                    this.propertyList = res.data.data;
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: "warning",
                    });
                }
            });
    },
    methods: {
        excel() {
            // this.$axios.post(
            //   "excel/infos",
            //   this.$qs.stringify({ token: sessionStorage.getItem("token") })
            // ).then(res=>{
            //   console.log(res)
            //   window.location.href=res
            // });

            window.location.href = this.$URL + "/excel/infos";
        },
        del() {
            let that = this;
            this.$confirm("删除用户, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    that.$axios
                        .post(
                            "company/del?token=" + sessionStorage.getItem("token"),
                            that.$qs.stringify({ ID: that.user.ID })
                        )
                        .then((res) => {
                            if (res.data.code == 10000) {
                                that.$message({
                                    type: "success",
                                    message: res.data.msg,
                                });
                                that.getInfo();
                                that.Popups(0);
                            } else {
                                that.$message(res.data.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        changpswd() {
            let that = this;
            const regex = /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%_^&*.?\\(\\)])(?!.*?[^\S*]).*$/;

            if (!regex.test(this.form.password1)) {
                this.$message({
                    message: "密码要求：长度为8-16个字符，必须包含大小写字母、数字、特殊符号（!@#$%_^&*.?不包括空格）",
                    type: "warning",
                });
                return;
            }
            this.$confirm("确认修改密码, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    that.$axios
                        .post(
                            "welcome/zmxsetpwd?token=" + sessionStorage.getItem("token"),
                            that.$qs.stringify(that.form)
                        )
                        .then((res) => {
                            if (res.data.code == 10000) {
                                that.$message({
                                    type: "success",
                                    message: res.data.msg,
                                });
                                that.dialogFormVisible = false;
                            } else {
                                that.$message(res.data.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消修改",
                    });
                });
        },
        show(name) {
            let that = this;
            switch (name) {
                case "名称":
                    that.table.Name = false;
                    break;
                case "隶属关系":
                    that.table.SuperiorDName = false;
                    break;
                case "地址":
                    that.table.City = false;
                    break;
                case "企业性质":
                    that.table.PropertyName = false;
                    break;
                case "邮箱":
                    that.table.Email = false;
                    break;
                case "联系人员":
                    that.table.Manager = false;
                    break;
                case "所在部门":
                    that.table.Department = false;
                    break;
                case "职务":
                    that.table.Position = false;
                    break;
                case "联系电话":
                    that.table.Phone = false;
                    break;
                case "统一代码":
                    that.table.Code = false;
                    break;
                case "企业简介":
                    that.table.introduction = false;
                    break;
                default:
                    break;
            }
        },
        yincang(name) {
            let that = this;
            switch (name) {
                case "名称":
                    that.table.Name = true;
                    break;
                case "隶属关系":
                    that.table.SuperiorDName = true;
                    break;
                case "地址":
                    that.table.City = true;
                    break;
                case "企业性质":
                    that.table.PropertyName = true;
                    break;
                case "邮箱":
                    that.table.Email = true;
                    break;
                case "联系人员":
                    that.table.Manager = true;
                    break;
                case "所在部门":
                    that.table.Department = true;
                    break;
                case "职务":
                    that.table.Position = true;
                    break;
                case "联系电话":
                    that.table.Phone = true;
                    break;
                case "统一代码":
                    that.table.Code = true;
                    break;
                default:
                    break;
            }
        },
        getqiye: function () {
            let that = this;
            this.table.PropertyName = true;
            console.log(this.user.Property, '企业性质');
            this.propertyList.forEach((val) => {
                if (that.user.Property == val.code) {
                    that.user.PropertyName = val.codename;
                }
            });
        },
        submitUpload() {
            this.$refs.uploads.submit();
        },
        // 测试上传
        handleSuccess(response, file, fileList) {
            console.log(response);
            console.log(file, fileList);
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === "image/jpeg" || "image/gif" || "image/png";
            // const isLt2M = file.size / 1024 / 1024 < 2;

            // if (!isJPG) {
            //   this.$message.error("上传图片只能是图片格式!");
            // }
            // if (!isLt2M) {
            //   this.$message.error("上传图片大小不能超过 2MB!");
            // }
            // return isJPG && isLt2M;
            console.log(file);
            return true;
        },
        upload(file) {
            let that = this;
            // console.log(file);
            var formData = new FormData();
            formData.append("file", file.file);
            formData.append("upload_type", "image");
            that.$axios
                .post("upload/index?", formData, {
                    headers: {
                        "Content-type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 10000) {
                        // this.company.Image = res.data.data;
                        this.user.Image = res.data.data;
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                    }
                });
            this.$refs.uploads.clearFiles();
        },
        uploadImg() {
            document.querySelector(".avatar-uploader1 input").click();
        },
        handleNodeClick(data) {
            console.log(data);
        },
        Popups(a) {
            console.log(a);
            if (a == 0) {
                for (var key in this.table) {
                    this.table[key] = true;
                }
            }
            this.CompanyID = a;
            a == 1 ? (this.useRtype = false) : (this.useRtype = true);

            this.getCompany(a);
            // this.isPopup = !this.isPopup;
            this.detailVisible = true
        },
        getInfo() {
            var that = this;
            that.$axios.post("company/trees?token=" + sessionStorage.getItem("token") + "&ID=1").then((res) => {
                if (res.data.code == 10000) {
                    this.tableData = [];

                    this.tableData.push(res.data.data.list);
                    console.log(this.tableData, 'this.tableData')
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: "warning",
                    });
                }
            });
        },
        getCompany(a) {
            var that = this;
            if (!a) {
                return;
            }
            that.$axios.post("company/info?token=" + sessionStorage.getItem("token") + "&ID=" + a).then((res) => {
                if (res.data.code == 10000) {
                    console.log(res.data.data, 1111);
                    this.form.ID = res.data.data.ID;
                    this.SuperiorIds = res.data.pids
                    this.user = res.data.data;
                    // console.log(this.user);
                } else {
                    this.$message({
                        message: res.data.msg,
                        type: "warning",
                    });
                }
            });
        },
        setInfo() {
            var that = this;
            this.$confirm("确认修改吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    console.log(this.user);
                    if (that.user.Property == 0) {
                        that.user.Property = "";
                    }
                    that.$axios
                        .post("company/update?token=" + sessionStorage.getItem("token"), that.$qs.stringify(this.user))
                        .then((res) => {
                            console.log(res);
                            if (res.data.code == 10000) {
                                // that.$axios
                                //   .post(
                                //     "message/updatestatus",
                                //     that.$qs.stringify({
                                //       type: 0,
                                //       operator: that.form.ID,
                                //       token: sessionStorage.getItem("token")
                                //     })
                                //   )
                                //   .then(res => {
                                //     console.log(res);
                                //   });
                                that.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                that.getInfo();
                                this.Popups(0);
                            } else {
                                that.$message.error(res.data.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消修改",
                    });
                });
        },
        getcompanyList() {
            this.$axios
                .post(
                    "company/index?token=" + sessionStorage.getItem("token"),
                    this.$qs.stringify({
                        name: this.name,
                        phone: this.phone,
                        page: this.Page1,
                        num: this.PageSize1
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        this.tableDatas = res.data.data.list;
                        this.total = res.data.data.total_num;
                        // var st = (this.Page1 - 1) * this.PageSize1;
                        // this.tableDatas = this.tableDatas.slice(
                        //     this.Page1 == 1 ? 0 : st,
                        //     this.PageSize1 * this.Page1
                        // );
                        // console.log(this.tableDatas, 'data')
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.data.msg,
                        });
                    }
                });
        },
        CurrentChange1(val) {
            //console.log(val)
            this.Page1 = val;
            this.getcompanyList();
        },
        handleSizeChange1(val) {
            //console.log(val)
            this.PageSize1 = val;
            this.getcompanyList();
        },
        getdata(id) {
            this.Popups(id)
        },
        changeSuperiorDName() {
            this.SuperiorD = true
            this.showCascader = false
            setTimeout(() => {
                this.showCascader = true
            }, 100)
        },
        changeSuperior() {
            this.$confirm("一经修改马上执行，确认修改吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    const params = {
                        com_id: this.user.ID,
                        par_id: this.SuperiorIds[this.SuperiorIds.length - 1]
                    }
                    console.log(params, 'user')
                    this.$axios
                        .post(
                            "company/structure?token=" + sessionStorage.getItem("token"),
                            this.$qs.stringify(params)
                        )
                        .then((res) => {
                            if (res.data.code == 10000) {
                                this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                })
                                this.SuperiorD = false
                                // this.getCompany(this.user.ID)
                                this.$router.go(0)
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: res.data.msg,
                                });
                            }
                        })
                })

        },
    },
    watch: {
        name: function () {
            clearTimeout(this.time);
            this.Page1 = 1
            this.time = setTimeout(() => {
                this.getcompanyList();
            }, 1000);
        },
        phone: function () {
            clearTimeout(this.time);
            this.Page1 = 1
            this.time = setTimeout(() => {
                this.getcompanyList();
            }, 1000);
        },
    },
    components: {
        Head,
        Foot,
        Nav,
        Mytree,
        Bgjurisdiction,
        wangEditor,
    },
};
</script>
<style lang="less">
#Structure {
    .editor {
        .text {
            min-height: 50px;
            max-height: 100px;
            overflow: auto;
        }
    }

    .el-image-viewer__close {
        background-image: url("../../assets/back/guanbi.png");
        background-repeat: no-repeat;
        background-size: cover;

        .el-icon-circle-close:before {
            content: "";
        }
    }

    .el-dialog__headerbtn {
        z-index: 1000;
    }

    .el_bgj .el-dialog__body {
        padding: 10px 20px;
    }

    #Hotspot {
        .hotspot {
            padding: 0;
        }

        .H-right {
            border: 0;
            float: none;
            // padding-left: 0;
            padding: 0 0.2rem 0 0;

            .Popup {
                text-align: left;
            }
        }
    }
}
</style>
<style scoped lang="less">
.clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}

.btn {
    width: 2.63rem;
    cursor: pointer;
    height: 0.7rem;
    line-height: 0.7rem;
    font-size: 0.17rem;
    text-align: center;
    background: #426cc4;
    color: #fff;
}

.btnchange {
    background-color: #f2f2f4;
    color: #000000;
}

.btnmini {
    width: 1rem;
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0.05rem;
}

.hotspot {
    // width: 100%;
    // min-width: 1000px;
    // padding: 0.28rem 2.54rem;
    font-size: 0.16rem;
    box-sizing: border-box;

    display: flex;
    justify-content: center;
    padding: 0.28rem .5rem;


    .H-right {
        position: relative;
        width: 65%;
        // width: 11.17rem;
        // min-width: 750px;
        padding-left: 0.2rem;
        height: 100%;
        float: right;
        min-height: 7.4rem;
        border-left: 1px #eeeeee solid;

        .btn1 {
            background: #2d65d2;
            width: 1.5rem;
            height: 0.5rem;
            color: #fff;
            border-radius: 0.05rem;
            text-align: center;
            line-height: 0.5rem;
            display: flex;
            position: absolute;
            right: 0.5rem;
            cursor: pointer;
            top: 1.1rem;
            z-index: 10;

            // justify-content: center;
            // align-items: center;
            i {
                margin: 0.1rem 0 0 0.1rem;
                width: 0.5rem;
                height: 0.5rem;
                background-image: url("../../assets/back/Excel.png");
                background-repeat: no-repeat;

                // background-size: 50%  100%;
            }
        }

        .title {
            font-size: 0.4rem;
            margin: 0.2rem 0 0.5rem;
            text-align: center;
        }

        .btnselect {
            display: flex;
        }

        .H-header {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 0.5rem;

            span,
            select,
            div {
                margin-right: 0.2rem;
            }
        }
    }
}

// .Popup {
// width: 100%;
// position: absolute;
// top: 0;
// height: 100%;
// background: rgba(0, 0, 0, 0.6);
// z-index: 1000;

.none {
    width: 100%;
    height: 100%;
    position: relative;
}

.f-top {
    // height: 0.5rem;
    width: 100%;
    text-align: center;
    line-height: 0.5rem;
    position: relative;
    border-bottom: 1px #cfcfcf solid;

    div {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
        height: 0.5rem;
        width: 0.5rem;
        background: url("../../assets/back/x.png") center center no-repeat;
    }
}

.a_forms {
    // position: fixed;
    // left: 60%;
    // top: 1rem;
    // transform: translate(-50%, 0);
    // width: 10.11rem;
    // background: white;
    // font-size: 0.16rem;
    // overscroll-behavior: contain;


    .f-info {
        padding: 0 0.54rem;

        .f-title {
            position: relative;
            overflow: hidden;
            // padding-bottom: 0.1rem;
            border-bottom: 1px #cfcfcf solid;

            .f-left {
                overflow: hidden;
                position: relative;

                >div {
                    margin: 0.3rem 0.18rem;
                    vertical-align: top;

                    >img {
                        max-width: 3rem;
                        max-height: 2rem;
                        margin-left: 1.2rem;
                        margin-top: -0.32rem;
                        cursor: pointer;
                    }

                    >span {
                        width: 0.8rem;
                        text-align: justify;
                        text-align-last: justify;
                        color: #505050;
                        display: inline-block;
                    }

                    >a {
                        color: #505050;
                        font-style: normal;
                    }

                    >em {
                        //  min-width: 2.5rem;
                        max-width: 2.5rem;
                        height: 0.2rem;
                        display: inline-flex;
                        margin: 0 0.1rem;
                        color: #272727;
                        font-style: normal;
                        cursor: pointer;
                        text-decoration: underline;
                        text-underline-offset: 2px;
                        text-decoration-color: #505050
                    }

                    >em:hover {
                        color: #426cc4;
                    }

                    >input {
                        margin-left: 0.3rem;
                        display: inline-block;
                        height: 0.3rem;
                    }

                    .toInput {
                        height: 0.3rem;
                        width: 2.5rem;
                        // margin-bottom: 0.1rem;
                        // margin-right: 0.2rem;
                    }
                }

                .qyjj {
                    margin-top: 0.3rem;
                    display: flex;
                    width: 50%;

                    // > textarea {
                    //   margin-left: 0.3rem;
                    //   display: inline-block;
                    //   vertical-align: text-top;
                    //   width: 80%;
                    // }
                    >.txt {
                        max-width: 3.4rem;
                        max-height: 1rem;
                        overflow: auto;
                        margin-left: 0.3rem;
                    }

                    .editor {
                        width: 80%;
                        margin-left: 0.3rem;
                    }
                }
            }

            .f-right {
                position: absolute;
                top: 0;
                right: 0;
                width: 50%;
            }
        }

        .f-bottom {
            margin: 0.2rem 0.2rem;
            display: flex;
            align-items: center;
        }
    }
}

// }

input,
select {
    padding: 0.01rem 0 0.01rem 0.05rem;
    height: 0.4rem;
    width: 2.5rem;
    margin-bottom: 0.1rem;
    margin-right: 0.2rem;
}
</style>
